import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { redirectWindowUrl } from "../../../services/GlobalUrls";
import { Tooltip } from "@mui/material";
import composedServiceUserMainCandidateContainer from "../../../containers/ServiceUserDetailsCandidateContainer";
import ServiceUsersCandidateList from "./ServiceUsersCandidateList";
import ServiceUserCandidateListMobile from "./ServiceUserCandidateListMobile";
import ViewServiceUserDetailsCandidate from "./ViewServiceUserDetailsCandidate";

const ServiceUserMainCandidate = ({ deviceInfo, ...props }) => {
  const [viewToolTip, setViewToolTip] = useState(false);
  const [getPathName, setPathName] = useState(window?.location?.pathname);

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 mb-2">
                <h5 className="font-weight-700 pull-left text-uppercase">
                  {getPathName == "/service-user-details"
                    ? "Service User Details"
                    : "Service Users"}
                </h5>
                {getPathName == "/service-user-details" && (
                  <>
                    {deviceInfo && deviceInfo == "Mobile" ? (
                      <Tooltip
                        title="Back"
                        className="text-sm"
                        open={viewToolTip}
                        placement="top"
                      >
                        <a
                          href={"/service-users"}
                          className="pull-right btn btn-dark text-white btn-sm"
                          onTouchStart={(e) => {
                            setViewToolTip(true);
                          }}
                          onTouchEnd={(e) => {
                            setViewToolTip(false);
                          }}
                        >
                          <i className="fa fa-chevron-left"></i>
                        </a>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title="Back"
                        className=""
                        open={viewToolTip}
                        placement="top"
                      >
                        <a
                          href={"/service-users"}
                          className="pull-right btn btn-dark text-white btn-sm"
                          onMouseEnter={(e) => {
                            setViewToolTip(true);
                          }}
                          onMouseLeave={(e) => {
                            setViewToolTip(false);
                          }}
                        >
                          <i className="fa fa-chevron-left"></i>
                        </a>
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {getPathName == "/service-user-details" ? (
          <>
            <ViewServiceUserDetailsCandidate />
          </>
        ) : (
          <>
            {deviceInfo && deviceInfo == "Mobile" ? (
              <ServiceUserCandidateListMobile />
            ) : (
              <ServiceUsersCandidateList />
            )}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default composedServiceUserMainCandidateContainer(
  ServiceUserMainCandidate
);
